module.exports = __webpack_public_path__ + "static/media/the-etho-homepage-curated-1.914ba462.jpg";